import { Stack } from '@mui/material';
import RadioComponent from '../../../fieldComponents/radioComponent/RadioComponent';
import Card from '../../card/Card';
import './Printer.scss';
import PrinterModule from './PrinterModule';
import { ApiQueryParam, PrinterType } from '../../../enums/enum';
import { useAppInsightConsumer } from '../../context/AppInsightContext/AppInsightContext';
import { useAuth } from '../../context/AuthContext/AuthContext';
import { useDispatch } from 'react-redux';
import { appStateActions, useAppSelector } from '../../../store/store';

const Printer: React.FC = () => {
  const { trackEvent } = useAppInsightConsumer();
  const { userData } = useAuth();

  const dispatch = useDispatch();

  const { printerTypeData, reqValidity, packetReqLoading } = useAppSelector(
    (state) => state.appStateReducer,
  );

  const handlePrinterRadioData = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    //AppInsight Logging
    trackEvent(
      `${event?.target?.value} printer is selected by ${userData?.profile?.email}`,
    );

    // Update the global printer state
    dispatch(
      appStateActions.updatePrinterTypeData(
        event?.target?.value as PrinterType,
      ),
    );
  };

  return (
    <Card title="Select a printer" stepNumber={1}>
      {packetReqLoading ? (
        // When the packet request Api is in loading state then show the disabled radio buttons
        <auro-radio-group
          required
          onClick={handlePrinterRadioData}
          error={
            // When valid, error should be undefined else show the error message
            reqValidity.printerType
              ? undefined
              : 'Please select the type of printer'
          }
          data-testid="radio-group-printer"
          disabled
        >
          {/* Laser */}
          <RadioComponent
            componentName="printer"
            label="Laser"
            value={PrinterType.LASER}
            checked // By default, Laser Printer will be checked
          />
          {/* Print File in fltops app server  */}

          <RadioComponent
            componentName="printer"
            label="FILE"
            value={PrinterType.FILE}
          />
        </auro-radio-group>
      ) : (
        // When the packet Api Request Api is in loading state then show the enabled radio buttons
        <auro-radio-group
          required
          onClick={handlePrinterRadioData}
          data-testid="radio-group-printer"
          error={
            // When valid error should be undefined else show the error message
            reqValidity.printerType
              ? undefined
              : 'Please select the type of printer'
          }
        >
          {/* Laser */}
          <RadioComponent
            componentName="printer"
            label="Laser"
            value={PrinterType.LASER}
            checked // By default Laser Printer will be checked
          />

          {/* Print File in fltops app server */}

          <RadioComponent
            componentName="printer"
            label="FILE"
            value={PrinterType.FILE}
          />
        </auro-radio-group>
      )}

      <Stack
        direction={{
          md: 'column',
          lg: 'row',
        }}
        gap={{
          xs: 4,
          md: 4,
          lg: 2,
        }}
      >
        {/* If the user selects Laser Printer, then show the Laser Printer component which contains
        dropdown for station and Laser Printers */}
        {printerTypeData === PrinterType.LASER && (
          <PrinterModule
            stationEndpoint={ApiQueryParam.GETLASERSTATIONS}
            printerEndpoint={ApiQueryParam.GETLASERPRINTERS}
            printerType={PrinterType.LASER}
            stationDropDownLabel={'City to print to'}
            printerDropDownLabel={'Select a printer'}
          />
        )}

        {/* Only if the printer is FAX then show the disclaimer */}
        {printerTypeData === PrinterType.FILE && (
          <i id="file-disclaimer-text">
            *Please checkout the packet in WebFinder or Fltops spools folder
            (for Support Team).
          </i>
        )}
      </Stack>
    </Card>
  );
};

export default Printer;
